import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { XMLElementBaseComponent } from '../base';

@Component({
  selector: 'app-xml-title',
  imports: [CommonModule],
  template: `
    <div class="w-full min-w-[80dvw] max-w-[90dvw]">
      <!-- <div class="bg-violet-50 text-xs">{{ data | json }}</div> -->
      <h2 class="w-full max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-lg font-semibold" [attr.title]="data.text">
        {{ data.text }}
        @if (data.children) {
          @for (child of data.children; track $index) {
            <span class="text-sm">{{ child.text }}</span>
          }
        }
      </h2>
    </div>
  `,
})
export class TitleComponent extends XMLElementBaseComponent {}
